import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import {Dropdown} from "primereact/dropdown";
import {Checkbox} from "primereact/checkbox";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import {InputTextarea} from "primereact/inputtextarea";
import {ALPHANUM_SPACE, ALPHANUM_SPACE_HT, CALENDAR_ES} from "../../../../utils/constants/Constants";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import TabViewPresval from "../../../../components/tabView/";
import LoadingOverlay from 'react-loading-overlay';

const UpdateInstitution = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'>
                {props.messagesGrowl}
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title="Mantenimiento \ Instituciones \ Edición"/>
                        </Grid>
                        <Grid item xs={6}>
                            <Button label="Guardar" style={{'float': 'right', marginRight: '.5em'}}
                                    onClick={props.updateInstitution}/>
                            <Button label="Regresar" style={{'float': 'right', marginRight: '.5em'}}
                                    className="p-button-secondary"
                                    onClick={props.handleReturnButton}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TabViewPresval modelOptions={props.items}
                                            activeIndex={props.activeIndex}
                                            onSelect={props.selectedIndexSteps}/>

                        </Grid>
                        {props.activeIndex === 0 &&
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <SubtitleLabel header="Datos de la Institución" isBold={true}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Button label="Siguiente" style={{'float': 'right', marginRight: '.5em'}}
                                        className="p-button-secondary"
                                        onClick={props.goNextStep}/>
                            </Grid>
                            <Grid item xs={12}>
                                <div className="p-grid">
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Institución Fiduciario" isBold={true}/>
                                        <SubtitleLabel header={props.catInstitution.NomInstFinanCorto}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Nombre" isBold={true}/>
                                        <InputText name="nombreCorto"
                                                   placeholder={"Ex: AAAA999999XYZ"}
                                                   maxLength={50}
                                                   value={props.institution.nombreCorto}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Tipo de Préstamo" isBold={true}/>
                                        <Dropdown
                                            name="catTypeLoan"
                                            filter={true}
                                            filterBy="descripcionId"
                                            options={props.typeLoan}
                                            optionLabel="descripcionId"
                                            placeholder="Seleccione..."
                                            onChange={props.saveDataInstitution}
                                            value={props.institution.catTypeLoan}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Rol" isBold={true}/>
                                        <Dropdown
                                            name="catRole"
                                            filter={true}
                                            filterBy="DescripcionRol"
                                            options={props.role}
                                            optionLabel="DescripcionRol"
                                            placeholder="Seleccione..."
                                            onChange={props.saveDataInstitution}
                                            value={props.institution.catRole}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="RFC" isBold={true}/>
                                        <InputText name="rfc"
                                                   keyfilter="alphanum"
                                                   placeholder={"Ex: AAAA999999XYZ"}
                                                   maxLength={13}
                                                   value={props.institution.rfc}
                                                   onChange={props.saveDataAlphaNum}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Razón Social" isBold={true}/>
                                        <SubtitleLabel header={props.institution.razonSocial}
                                                       hidden={props.isEditableRS}/>
                                        <InputText name="razonSocial"
                                                   placeholder={"Ex: AAAA999999XYZ"}
                                                   maxLength={100}
                                                   value={props.institution.razonSocial}
                                                   onChange={props.saveDataInstitution}
                                                   hidden={!props.isEditableRS}/>
                                    </div>
                                    <div className="p-col-6"/>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Contrato" isBold={true}/>
                                        <InputText name="contrato"
                                                   keyfilter="pint"
                                                   placeholder={"Ex: 99999999"}
                                                   maxLength={8}
                                                   value={props.institution.contrato}
                                                   onChange={props.saveDataPint}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Tipo de Instrumento" isBold={true}/>
                                        <Dropdown
                                            name="catInstrument"
                                            filter={true}
                                            filterBy="DescripcionInstrumento"
                                            options={props.instrument}
                                            optionLabel="DescripcionInstrumento"
                                            placeholder="Seleccione..."
                                            onChange={props.saveDataInstitution}
                                            value={props.institution.catInstrument}
                                        />
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Status" isBold={true}/>
                                        <Dropdown
                                            name="catStatus"
                                            filter={true}
                                            filterBy="descripcionId"
                                            options={props.status}
                                            optionLabel="descripcionId"
                                            placeholder="Seleccione..."
                                            onChange={props.saveDataInstitution}
                                            value={props.institution.catStatus}/>
                                    </div>
                                    <div className="p-col-3">
                                        <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                            <br/>
                                            <Checkbox
                                                name="seleccionGaran"
                                                checked={props.institution.seleccionGaran}
                                                onChange={props.saveDataCheckInstitution}/> &nbsp;
                                            Selección de Garantías
                                        </Typography>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Num. Esc. Cons." isBold={true}/>
                                        <InputText name="numEscCon"
                                                   keyfilter="pint"
                                                   placeholder={"Ex: 99999999"}
                                                   maxLength={9}
                                                   value={props.institution.numEscCon}
                                                   onChange={props.saveDataPint}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Fecha Escritura" isBold={true}/>
                                        <Calendar
                                            name="escrituraFec"
                                            dateFormat={"dd/mm/yy"}
                                            value={props.institution.escrituraFec}
                                            disabledDays={[0, 6]}
                                            readOnlyInput={true}
                                            onChange={props.saveDataInstitution}
                                            maxDate={props.today}
                                            monthNavigator={true}
                                            yearNavigator={true}
                                            yearRange={CALENDAR_ES['yearRange']}
                                            locale={CALENDAR_ES}
                                            showButtonBar={true}
                                        />
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Reg. Pub. Comer." isBold={true}/>
                                        <InputText name="recPubComer"
                                                   keyfilter="pint"
                                                   placeholder={"Ex: 99999999"}
                                                   maxLength={16}
                                                   value={props.institution.recPubComer}
                                                   onChange={props.saveDataPint}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Fecha Reg. Pub." isBold={true}/>
                                        <Calendar
                                            name="regPubFec"
                                            dateFormat={"dd/mm/yy"}
                                            value={props.institution.regPubFec}
                                            disabledDays={[0, 6]}
                                            readOnlyInput={true}
                                            onChange={props.saveDataInstitution}
                                            maxDate={props.today}
                                            monthNavigator={true}
                                            yearNavigator={true}
                                            yearRange={CALENDAR_ES['yearRange']}
                                            locale={CALENDAR_ES}
                                            showButtonBar={true}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="No. Poder" isBold={true}/>
                                        <InputText name="powerNumber"
                                                   keyfilter="pint"
                                                   placeholder={"Ex: 99999999"}
                                                   maxLength={9}
                                                   value={props.institution.powerNumber}
                                                   onChange={props.saveDataPint}/>
                                    </div>
                                    <div className="p-col-3">
                                        <SubtitleLabel header="Fecha Poder" isBold={true}/>
                                        <Calendar
                                            name="powerDate"
                                            dateFormat={"dd/mm/yy"}
                                            value={props.institution.powerDate}
                                            disabledDays={[0, 6]}
                                            readOnlyInput={true}
                                            onChange={props.saveDataInstitution}
                                            maxDate={props.today}
                                            monthNavigator={true}
                                            yearNavigator={true}
                                            yearRange={CALENDAR_ES['yearRange']}
                                            locale={CALENDAR_ES}
                                            showButtonBar={true}/>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        }
                        {props.activeIndex === 1 &&
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <SubtitleLabel header="Dirección Fiscal" isBold={true}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Button label="Siguiente" style={{'float': 'right', marginRight: '.5em'}}
                                        className="p-button-secondary"
                                        onClick={props.goNextStep}/>
                                <Button label="Anterior" style={{'float': 'right', marginRight: '.5em'}}
                                        className="p-button-secondary"
                                        onClick={props.goPreviousStep}/>
                            </Grid>
                            <Grid item xs={12}>
                                <div className="p-grid">
                                    <div className="p-col-2">
                                        <SubtitleLabel header="Calle y Número" isBold={true}/>
                                        <InputText name="fisCalle"
                                                   keyfilter={ALPHANUM_SPACE_HT}
                                                   maxLength={255}
                                                   value={props.institution.fisCalle}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="Colonia" isBold={true}/>
                                        <InputText name="fisColonia"
                                                   keyfilter={ALPHANUM_SPACE}
                                                   maxLength={255}
                                                   value={props.institution.fisColonia}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="CP" isBold={true}/>
                                        <InputText name="fisCP"
                                                   keyfilter="pint"
                                                   maxLength={10}
                                                   value={props.institution.fisCP}
                                                   onChange={props.saveDataPint}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="Ciudad" isBold={true}/>
                                        <InputText name="fisCiudad"
                                                   keyfilter={ALPHANUM_SPACE}
                                                   maxLength={120}
                                                   value={props.institution.fisCiudad}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="Estado" isBold={true}/>
                                        <InputText name="fisEstado"
                                                   keyfilter={ALPHANUM_SPACE}
                                                   maxLength={70}
                                                   value={props.institution.fisEstado}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="País" isBold={true}/>
                                        <InputText name="fisPais"
                                                   keyfilter={ALPHANUM_SPACE}
                                                   maxLength={70}
                                                   value={props.institution.fisPais}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider/>
                            </Grid>
                            <Grid item xs={12}>
                                <SubtitleLabel header="Dirección Correspondencia" isBold={true}/>
                            </Grid>
                            <Grid item xs={12}>
                                <div className="p-grid">
                                    <div className="p-col-2">
                                        <SubtitleLabel header="Calle y Número" isBold={true}/>
                                        <InputText name="corrCalle"
                                                   keyfilter={ALPHANUM_SPACE_HT}
                                                   maxLength={255}
                                                   value={props.institution.corrCalle}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="Colonia" isBold={true}/>
                                        <InputText name="corrColonia"
                                                   keyfilter={ALPHANUM_SPACE}
                                                   maxLength={255}
                                                   value={props.institution.corrColonia}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="CP" isBold={true}/>
                                        <InputText name="corrCP"
                                                   keyfilter="pint"
                                                   maxLength={10}
                                                   value={props.institution.corrCP}
                                                   onChange={props.saveDataPint}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="Ciudad" isBold={true}/>
                                        <InputText name="corrCiudad"
                                                   keyfilter={ALPHANUM_SPACE}
                                                   maxLength={120}
                                                   value={props.institution.corrCiudad}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="Estado" isBold={true}/>
                                        <InputText name="corrEstado"
                                                   keyfilter={ALPHANUM_SPACE}
                                                   maxLength={70}
                                                   value={props.institution.corrEstado}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                    <div className="p-col-2">
                                        <SubtitleLabel header="País" isBold={true}/>
                                        <InputText name="corrPais"
                                                   keyfilter={ALPHANUM_SPACE}
                                                   maxLength={70}
                                                   value={props.institution.corrPais}
                                                   onChange={props.saveDataInstitution}/>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider/>
                            </Grid>
                            <Grid item xs={6}>
                                <SubtitleLabel header="Contactos" isBold={true}/>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{textAlign: 'right'}}>
                                    <Button type="button" iconPos="left" label="Agregar"
                                            style={{marginRight: '.5em'}}
                                            className="p-button-secondary"
                                            onClick={() => props.openAddContact("")}/>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div className="p-col-12">
                                    <DataTable
                                        value={props.contactList}
                                        selectionMode="single"
                                        resizableColumns={true}
                                        columnResizeMode={"fit"}>
                                        <Column
                                            field="tipoMedioComunica"
                                            header="Tipo"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column
                                            field="decripcionMedioComunica"
                                            header="Descripción"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column
                                            field="contactoOperativo"
                                            header="Contacto Operativo"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column
                                            field="rolContacto"
                                            header="Rol Contacto"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column header="Acciones"
                                                body={props.contactActionTemplate}
                                                style={{textAlign: 'center', width: '8em'}}/>
                                    </DataTable>
                                </div>
                            </Grid>
                        </Grid>
                        }
                        {props.activeIndex === 2 &&
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <SubtitleLabel header="Firmas" isBold={true}/>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{textAlign: 'right'}}>
                                    <Button label="Anterior" style={{marginRight: '.5em'}}
                                            className="p-button-secondary"
                                            onClick={props.goPreviousStep}/>
                                    <Button label="Siguiente" style={{marginRight: '.5em'}}
                                            className="p-button-secondary"
                                            onClick={props.goNextStep}/>
                                    <Button type="button" label="Agregar"
                                            style={{marginRight: '.5em'}}
                                            className="p-button-secondary"
                                            onClick={props.openAddSigns}/>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div className="p-col-12">
                                    <DataTable
                                        value={props.signList}
                                        selectionMode="single"
                                        resizableColumns={true}
                                        columnResizeMode={"fit"}>
                                        <Column
                                            field="apellidoPaterno"
                                            header="Apellido Paterno"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column
                                            field="apellidoMaterno"
                                            header="Apellido Materno"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column
                                            field="nombre"
                                            header="Nombre(s)"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column
                                            field="tipoFirma"
                                            header="Tipo Firma"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column
                                            field="identificacion"
                                            header="Identificación"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column
                                            field="fechaVencimiento"
                                            header="Fecha Vencimiento"
                                            style={{textAlign: 'left'}}
                                            sortable={true}/>
                                        <Column header="Acciones"
                                                body={props.deleteSignActionTemplate}
                                                style={{textAlign: 'center', width: '8em'}}/>
                                    </DataTable>
                                </div>
                            </Grid>
                        </Grid>
                        }
                        {props.activeIndex === 3 &&
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <SubtitleLabel header="Anexos" isBold={true}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Button label="Anterior" style={{'float': 'right', marginRight: '.5em'}}
                                        className="p-button-secondary"
                                        onClick={props.goPreviousStep}/>
                            </Grid>
                            <Grid item xs={12}>
                                <div className="p-grid">
                                    <div className="p-col-3">
                                        <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                            <Checkbox
                                                name="contratoServicios"
                                                checked={props.institution.contratoServicios}
                                                onChange={props.saveDataCheckInstitution}/> &nbsp;
                                            Contrato de Servicios
                                        </Typography>
                                    </div>
                                    <div className="p-col-3">
                                        <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                            <Checkbox
                                                name="comprobanteDomicilio"
                                                checked={props.institution.comprobanteDomicilio}
                                                onChange={props.saveDataCheckInstitution}/> &nbsp;
                                            Comprobante de Domicilio
                                        </Typography>
                                    </div>
                                    <div className="p-col-3">
                                        <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                            <Checkbox
                                                name="poderesNotariales"
                                                checked={props.institution.poderesNotariales}
                                                onChange={props.saveDataCheckInstitution}/> &nbsp;
                                            Poderes Notariales
                                        </Typography>
                                    </div>
                                    <div className="p-col-3">
                                        <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                            <Checkbox
                                                name="actaConstitutiva"
                                                checked={props.institution.actaConstitutiva}
                                                onChange={props.saveDataCheckInstitution}/> &nbsp;
                                            Acta Constitutiva
                                        </Typography>
                                    </div>
                                    <div className="p-col-12">
                                        <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                            <Checkbox
                                                name="comprobanteRFC"
                                                checked={props.institution.comprobanteRFC}
                                                onChange={props.saveDataCheckInstitution}/> &nbsp;
                                            Comprobante de RFC
                                        </Typography>
                                    </div>
                                </div>
                            </Grid>
                            <div className="p-col-12">
                                <Divider/>
                            </div>
                            <div className="p-col-12">
                                <SubtitleLabel header="GSS" isBold={true}/>
                            </div>
                            <div className="p-col-3">
                                <SubtitleLabel header="Cliente GSS" isBold={true}/>
                                <Dropdown
                                    name="catIdClientGss"
                                    showClear="true"
                                    filterBy="NOMREL"
                                    options={props.idClientGss}
                                    optionLabel="NOMREL"
                                    placeholder="Seleccione..."
                                    onChange={props.saveDataInstitution}
                                    value={props.institution.catIdClientGss}
                                />
                            </div>
                            <div className="p-col-3">
                                <SubtitleLabel header="ID Contraparte" isBold={true}/>
                                <InputText name="idContraparte"
                                           keyfilter="pint"
                                           placeholder={"Ex: 99999999"}
                                           maxLength={10}
                                           value={props.institution.idContraparte}
                                           onChange={props.saveDataInstitution}/>
                            </div>
                            <div className="p-col-6"/>
                            <div className="p-col-12">
                                <Divider/>
                            </div>
                            <div className="p-col-12">
                                <SubtitleLabel header="INDEVAL" isBold={true}/>
                            </div>
                            <div className="p-col-3">
                                <SubtitleLabel header="ID Institución" isBold={true}/>
                                <InputText name="idInst"
                                           keyfilter="pint"
                                           placeholder={"Ex: 12"}
                                           maxLength={2}
                                           value={props.institution.idInst}
                                           onChange={props.saveDataPint}/>
                            </div>
                            <div className="p-col-3">
                                <SubtitleLabel header="Folio Institución" isBold={true}/>
                                <InputText name="folioInst"
                                           keyfilter="pint"
                                           placeholder={"Ex: 3412"}
                                           maxLength={3}
                                           value={props.institution.folioInst}
                                           onChange={props.saveDataPint}/>
                            </div>
                            <div className="p-col-6"/>
                            <div className="p-col-3">
                                <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                    <br/>
                                    <Checkbox
                                        name="banderaCuentaEfvo"
                                        checked={props.institution.banderaCuentaEfvo}
                                        onChange={props.saveDataCheckInstitution}/> &nbsp;
                                    Cuenta Efectivo
                                </Typography>
                            </div>
                            <div className="p-col-3">
                                <SubtitleLabel header="Número de Cuenta Efectivo" isBold={true}/>
                                <InputText name="cuentaEfectivo"
                                           keyfilter="alphanum"
                                           placeholder={"Ex: 3412"}
                                           maxLength={35}
                                           value={props.institution.cuentaEfectivo}
                                           onChange={props.saveDataAlphaNum}/>
                            </div>
                            <div className="p-col-6">
                                <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                    <br/>
                                    <Checkbox
                                        name="banderaIndeval"
                                        checked={props.institution.banderaIndeval}
                                        onChange={props.saveDataCheckInstitution}/> &nbsp;
                                    INDEVAL
                                </Typography>
                            </div>
                            <div className="p-col-12">
                                <SubtitleLabel header="Observaciones" isBold={true}/>
                                <InputTextarea
                                    name="observaciones"
                                    placeholder={"Captura el texto del campo..."}
                                    rows={5}
                                    cols={150}
                                    value={props.institution.observaciones}
                                    onChange={props.saveDataInstitution}
                                    autoResize={true}
                                />
                            </div>
                        </Grid>
                        }
                    </Grid>
                </Paper>
            </LoadingOverlay>
        </React.Fragment>
    )
};

export default UpdateInstitution;